import React from 'react';
import './App.css';
import Converter from './components/Converter/Converter';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      </header>
      <main>
        <Converter />
      </main>
    </div>
  );
}

export default App;
